import { proxy } from 'valtio';

import { PromoInformationType } from './PromoForm/promoInformationSchema';
import { PurchaseRequirementSchemaType } from './PromoForm/PurchaseRequirement/purchaseRequirementSchema';

interface PromoState {
  dirtyFormExists: boolean;
  promoInformation?: PromoInformationType;
  purchaseRequirement?: PurchaseRequirementSchemaType;
}

const promoState = proxy<PromoState>({
  dirtyFormExists: false,
  promoInformation: undefined,
  purchaseRequirement: undefined,
});

export default promoState;
